import {BrowserRouter, Routes, Route} from "react-router-dom"
import Integral from "./pages/integral";
import Goods from "./pages/goods";
import Record from "./pages/record";
import Rule from "./pages/rule";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectSession, setSession} from "./global";
import JsonRequest from "./request/json_request";
import {flutterUser} from "./util";
import './index.css';
import CustomLoading from "./components/custom-loading";
import Rank from "./pages/rank";

function App() {
    const session = useSelector(selectSession)
    const dispatch = useDispatch()

    // 检查session状态
    const needsSession = !session || localStorage.getItem("authorization") !== flutterUser.authorization;

    useEffect(() => {
        if (needsSession) {
            try {
                JsonRequest.headerClient(flutterUser).get('/api/distributed/mall/session')
                    .then((resp) => {
                        console.log("Session response received")
                        return resp.json()
                    })
                    .then((result) => {
                        console.log("Session data:", result)
                        if (result && result.data) {
                            dispatch(setSession(result.data))
                        }
                    })
                    .catch((error) => {
                        console.error("Session request error:", error)
                    })
            } catch (error) {
                console.error("Session request failed:", error)
            }
        }
    }, [needsSession, dispatch])

    if (needsSession) {
        return <div className='page-loading'>
            <CustomLoading/>
        </div>
    } else {
        return <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" exact element={<Integral/>}/>
                    <Route path="/goods" exact element={<Goods/>}/>
                    <Route path="/record" exact element={<Record/>}/>
                    <Route path="/rule" exact element={<Rule/>}/>
                    <Route path="/rankList" exact element={<Rank/>}/>
                </Routes>
            </BrowserRouter>
        </>;
    }
}

export default App;
